import {useState, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {setModalAlert} from '../../reducers/app/actions';
import Selector from '../../selectors/modals/alert';

export default () => {
    const dispatch = useDispatch(),
          {alert} = useSelector(Selector),
          [close, setClose] = useState(false);
    
    const blur = useRef(),
          modal = useRef();

    const closeHandler = () => {
        if(close)
            return;

        setClose(true);

        if(blur.current) {
            blur.current.classList.remove('animate__animated');
            blur.current.classList.remove('animate__fadeIn');
            blur.current.classList.add('animate__fadeOut');
            blur.current.classList.add('animate__animated');
        }

        if(modal.current) {
            modal.current.classList.remove('animate__animated');
            modal.current.classList.remove(alert.type === "danger" ? 'animate__bounceIn' : "animate__zoomIn");
            modal.current.classList.add(alert.type === "danger" ? 'animate__bounceOut' : "animate__zoomOut");
            modal.current.classList.add('animate__animated');
        }

        setTimeout(() => {
            dispatch(setModalAlert(null));
            setClose(false);
        }, 600);
    }

    if(!alert)
        return <></>;

    return (
        <>
            <div className="blur animate__animated animate__faster animate__fadeIn" ref={blur} onClick={e => closeHandler()}></div>
            <div className={`modal modal-alert animate__animated animate__faster ${alert.type === "danger" ? "animate__bounceIn" : "animate__zoomIn"}`} ref={modal}>
                <div className="modal-header">
                    <div className="title">Venmo</div>
                    <div className="close" onClick={e => closeHandler()}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="40" height="40" rx="20" fill="#1E1F1F"/>
                            <path d="M15 25.8483L25.8483 15" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M25.8483 25.8483L15 15" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>

                <img src={`https://glazok.org/wp-content/uploads/2023/05/607fe10c48984142601548-768x512.png`} alt="" style={{width: "calc(100% - 20px)", borderRadius: "15px"}} />

                <div className="modal-alert-details">
                    <div className="title">Venmo</div>
                    <div className="text">
                        The Venmo deposit method is in beta testing.<br /><br /><b>Contact support to make a deposit using Venmo</b>
                    </div>

                    <div className="button blue" style={{marginTop: "10px"}} onClick={e => window.open(`https://t.me/casinos_support_bot`, '_blank')}>Contact support</div>
                </div>
                {/* <div className="modal-alert-details">
                    <div className="title">Test our beta!</div>
                    <div className="text">
                        <b>Contact live operator</b> to make a deposit using Cash App, please follow these simple steps:
                        <br /><br />
                        Reach out live operator to initiate your deposit process then <b>let the operator know the amount you'd like to deposit</b>. Deposits start from $20 and must be in whole numbers such as $20, $40, or $60. 
                        <br />
                        Once you've shared your desired deposit amount, please wait for a response from the operator 🤝
                    </div>

                    <div className="button blue" onClick={e => window.open(`https://t.me/casinos_support_bot`, '_blank')}>Contact support</div>
                </div> */}
            </div>
        </>
    )    
}